import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralDataRepository } from 'app/helpers/repository/general-data.repository';

@Component({
  selector: 'app-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss'],
})
export class MenuItemComponent {
  @Input() item!: IMenuItem;
  @Output() subMenuOpen = new EventEmitter<IMenuItem[]>();
  @Input() iconColor!: string;
  handleClick() {
    this.subMenuOpen.emit(this.item.subItems);
  }
  constructor(public router: Router) {}
}

export interface IMenuItem {
  name: string;
  link: string;
  imageLink: string;
  subItems: IMenuItem[] | undefined;
  disabled: boolean;
  notificationsCount?: number;
}
